import samplePortfolioExport from "../data/sample-portfolio.json";
import { parseProfileShare, profileDataForSections } from "./profileShare.js";

const allSections = { configuration: true, allocation: true, browserViews: true };

export function createSampleProfileDraft(profiles = []) {
  const share = parseProfileShare(samplePortfolioExport);
  return {
    name: uniqueSampleProfileName(profiles, share.profile.name),
    data: profileDataForSections(share, allSections)
  };
}

function uniqueSampleProfileName(profiles, sourceName) {
  const names = new Set(profiles.map((profile) => profile.name.trim().toLocaleLowerCase()));
  if (!names.has(sourceName.toLocaleLowerCase())) return sourceName;
  let number = 2;
  while (names.has(`${sourceName} ${number}`.toLocaleLowerCase())) number += 1;
  return `${sourceName} ${number}`;
}
